module.exports = __webpack_public_path__ + "img/6.7ad6ae30.png";